export const typStavZadostiSelect = [
    {
        value: 'U001',
        labelcz: 'SS_DETAIL_STAV_U001'
    },
    {
        value: 'U002',
        labelcz: 'SS_DETAIL_STAV_U002'
    },
    {
        value: 'U003',
        labelcz: 'SS_DETAIL_STAV_U003'
    },
    {
        value: 'U005',
        labelcz: 'SS_DETAIL_STAV_U005'
    },
    {
        value: 'U006',
        labelcz: 'SS_DETAIL_STAV_U006'
    },
    {
        value: 'U007',
        labelcz: 'SS_DETAIL_STAV_U007'
    },
    {
        value: 'U008',
        labelcz: 'SS_DETAIL_STAV_U008'
    },
    {
        value: 'U700',
        labelcz: 'SS_DETAIL_STAV_U700'
    },
    {
        value: 'U701',
        labelcz: 'SS_DETAIL_STAV_U701'
    },
    {
        value: 'U702',
        labelcz: 'SS_DETAIL_STAV_U702'
    },
    {
        value: 'U710',
        labelcz: 'SS_DETAIL_STAV_U710'
    },
    {
        value: 'U730',
        labelcz: 'SS_DETAIL_STAV_U730'
    },
    {
        value: 'U750',
        labelcz: 'SS_DETAIL_STAV_U750'
    },
    {
        value: 'U800',
        labelcz: 'SS_DETAIL_STAV_U800'
    },
    {
        value: 'U801',
        labelcz: 'SS_DETAIL_STAV_U801'
    },
    {
        value: 'U850',
        labelcz: 'SS_DETAIL_STAV_U850'
    },
    {
        value: 'U900',
        labelcz: 'SS_DETAIL_STAV_U900'
    },
    {
        value: 'U950',
        labelcz: 'SS_DETAIL_STAV_U950'
    }
];

export const typStavZadostiDLTSelect = [
    {
        value: 'U001',
        labelcz: 'SS_DETAIL_STAV_U001'
    },
    {
        value: 'U002',
        labelcz: 'SS_DETAIL_STAV_U002'
    },
    {
        value: 'U003',
        labelcz: 'SS_DETAIL_STAV_U003'
    },
    {
        value: 'U007',
        labelcz: 'SS_DETAIL_STAV_U007'
    },
    {
        value: 'U710',
        labelcz: 'SS_DETAIL_STAV_U710'
    },
    {
        value: 'U750',
        labelcz: 'SS_DETAIL_STAV_U750'
    },
    {
        value: 'U770',
        labelcz: 'SS_DETAIL_STAV_U770'
    },
    {
        value: 'U700',
        labelcz: 'SS_DETAIL_STAV_U700'
    },
    {
        value: 'U801',
        labelcz: 'SS_DETAIL_STAV_U801'
    },
    {
        value: 'U850',
        labelcz: 'SS_DETAIL_STAV_U850'
    },
    {
        value: 'U900',
        labelcz: 'SS_DETAIL_STAV_U900'
    },
    {
        value: 'U950',
        labelcz: 'SS_DETAIL_STAV_U950'
    }
];
